import axios from 'axios';
import { getJWT } from 'src/helper/localStore/getJWT';
import { IsAuthorized } from 'src/authentication/IsAuthorized';

class FlexibleRateService {
  async updateStatus(Id: number, status: string): Promise<void> {
    try {
      await axios.patch(
        `${process.env.REACT_APP_URL_RESERVATION}/air-detail/${Id}`,
        { flexible_rate_status: status },
        {
          headers: { 'authentication-token': getJWT()! },
        }
      );
    } catch (error) {
      IsAuthorized(error);
      throw error;
    }
  }
}

export const flexibleRateService = new FlexibleRateService();